import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=5181bd0c&scoped=true"
import script from "./EducationDetails.vue?vue&type=script&lang=ts"
export * from "./EducationDetails.vue?vue&type=script&lang=ts"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&id=5181bd0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181bd0c",
  null
  
)

export default component.exports